export const DATA_COMPILATION_TEMPLATE =
  'https://cdn.getsave.io/templates/data-compilation-template.xlsx';
export const DATA_COLLECTION_TEMPLATE =
  'https://cdn.getsave.io/templates/data-collection-template.pdf';
